/*
 * BeCBD - effets futuristes (progressive enhancement)
 * - Ajoute une classe becbd-js sur <html> pour activer les styles animes
 *   definis dans becbd-brand.css (section 18). Sans ce script, le site
 *   reste entierement statique et visible.
 * - Verre depoli sur l'en-tete des le premier scroll.
 * - Reveal au defilement (fondu + leger deplacement) sur les sections
 *   principales de la page, hors en-tete et pied de page.
 * Pour tout desactiver : retirer la balise <script> de ce fichier dans
 * layout/theme.liquid.
 */
(function () {
  document.documentElement.classList.add('becbd-js');

  var headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (headerGroup) {
    var toggleScrolled = function () {
      if (window.scrollY > 12) {
        headerGroup.classList.add('becbd-scrolled');
      } else {
        headerGroup.classList.remove('becbd-scrolled');
      }
    };
    toggleScrolled();
    window.addEventListener('scroll', toggleScrolled, { passive: true });
  }

  var sections = document.querySelectorAll('main .shopify-section');

  if ('IntersectionObserver' in window && sections.length) {
    sections.forEach(function (section) {
      section.classList.add('becbd-reveal');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }
})();
